import _ from 'lodash';

export default function getThumbnailPhotoUrlFromHash(photoHash, targetWidth) {
  if(!photoHash) {
    return null;
  }
  if(!photoHash.child_resolutions) {
    return photoHash.url;
  }
  let selected = _.find(photoHash.child_resolutions, (cr) => {return cr.width >= targetWidth;});
  return selected ? selected.url : photoHash.url;
}



// WEBPACK FOOTER //
// banquet/lib/getThumbnailPhotoUrlFromHash.js